module.exports = __webpack_public_path__ + "img/STC.33749b57.svg";